import action from './action';
import command from './command';

export { action, command };

export default {
  name: 'logout',
  description: 'Strapi Cloud Logout',
  action,
  command,
};
